import { render, staticRenderFns } from "./SgpEventPicker.vue?vue&type=template&id=e643e684"
import script from "./SgpEventPicker.vue?vue&type=script&lang=js"
export * from "./SgpEventPicker.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports